<template>
  <div id="terms1" class="fixed-top" v-if="visibleBack">
    <b-container fluid>
      <b-row  align-v="end">
        <b-col class="row-terms-blank" cols="12"></b-col>
        <transition
          name="custom-classes-transition"
          enter-active-class="animate__animated animate__backInUp"
          leave-active-class="animate__animated animate__backOutDown"
        >
          <b-col class="row-terms-text text-center" cols="12" v-if="visibleTermos">
            <p class="ensPrivacyTitle">Política de cookies</p>
            <p class="text-privacy"> Não fazemos uso de cookies, apenas dados para pré-matrícula de alunos(as). Ao continuar em nosso site, consideramos que está de acordo com nossos <b-link @click="launchTerms()" target="_blank"><span class="link-terms"> <b-badge variant="primary">termos</b-badge> </span></b-link> </p>
            <b-button class="btn-close-terms" pill variant="success" @click="closeTerms()">X</b-button>
          </b-col>
        </transition>
      </b-row>
    </b-container>
  </div>
</template>


<script>

export default {
  name: "accept",
  data() {
    return {
      visibleTermos: false,
      visibleBack: false
    }
  },
  created() {
    this.iniciaTermos()
  },
  methods: {
    iniciaTermos() {
      setTimeout(() => {
        this.visibleBack = true        
      }, 500);
      setTimeout(() => {
        this.visibleTermos = true
      }, 900);
    },
    closeTerms() {
      this.visibleTermos = !this.visibleTermos
      setTimeout(() => {
        this.visibleBack = false
      }, 500);
    },
    launchTerms() {
      let routeData = this.$router.resolve({name: 'termos'});
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>

  #terms1 {
    height: calc(100vh);
    background-color: rgba(0,0,0,0.8);
  }

  #terms1 .row-terms-blank {
    /* background-color: rgba(0,0,0,0.8); */
    height: calc(100vh - 150px);
  }

  #terms1 .row-terms-text {
    height: 150px !important;
    background-color: white;
    opacity: 0.9;
    z-index: 2000;
  }

  .ensPrivacyTitle {
    font-family: 'vw-head', sans-serif;
    font-weight: bold;
    font-size: 28px;
    line-height: 33px;
    letter-spacing: -0.025em;
    margin: 0 1 rem 1 rem !important;
    width: 91.66667%;
    font-weight: normal;
    font-style: normal;
  }

  .text-privacy {
    font-size: 14px;
    line-height: 20px;
  }

  .link-terms {
    color: black;
    font-weight: bold;
    font-size: 20px;
  }

  .btn-close-terms {
    position: fixed;
    right: 15px;
    bottom: 105px;
    background-color: #974548 !important;
    border-color: #974548;
  }

</style>




// WEBPACK FOOTER //
// src/views/accept.vue